/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, handle: NonNullable<unknown> }} Blog_Share_ViaInputs */

const en_blog_share_via = /** @type {(inputs: Blog_Share_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} via ${i?.handle}`)
};

const lv_blog_share_via = /** @type {(inputs: Blog_Share_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} — ${i?.handle}`)
};

/**
* | output |
* | --- |
* | "{title} via {handle}" |
*
* @param {Blog_Share_ViaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_share_via = /** @type {((inputs: Blog_Share_ViaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Share_ViaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_share_via(inputs)
	return en_blog_share_via(inputs)
});